/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistryShort } from './RegistryShort'
import {
  RegistryShortFromJSON,
  RegistryShortFromJSONTyped,
  RegistryShortToJSON,
} from './RegistryShort'

/**
 *
 * @export
 * @interface SiteGetRegistry200Response
 */
export interface SiteGetRegistry200Response {
  /**
   *
   * @type {boolean}
   * @memberof SiteGetRegistry200Response
   */
  status: boolean
  /**
   *
   * @type {RegistryShort}
   * @memberof SiteGetRegistry200Response
   */
  data: RegistryShort
}

/**
 * Check if a given object implements the SiteGetRegistry200Response interface.
 */
export function instanceOfSiteGetRegistry200Response(
  value: object
): value is SiteGetRegistry200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function SiteGetRegistry200ResponseFromJSON(
  json: any
): SiteGetRegistry200Response {
  return SiteGetRegistry200ResponseFromJSONTyped(json, false)
}

export function SiteGetRegistry200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SiteGetRegistry200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: RegistryShortFromJSON(json['data']),
  }
}

export function SiteGetRegistry200ResponseToJSON(
  value?: SiteGetRegistry200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: RegistryShortToJSON(value['data']),
  }
}
